'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANNUAL_PLACEHOLDER = exports.MONTHLY_PLACEHOLDER = exports.ANNUAL_BASIC_TO_PRO_DISCOUNT = exports.ANNUAL_10_PERCENT_DISCOUNT = exports.MONTHLY_30_PERCENT_DISCOUNT = exports.ANNUAL_30_PERCENT_DISCOUNT = exports.ANNUAL_50_PERCENT_DISCOUNT = exports.ANNUAL_60_PERCENT_DISCOUNT = exports.HSFS_90_PERCENT_DISCOUNT = exports.HSFS_50_PERCENT_DISCOUNT = exports.HSFX_ENTREPRENEUR_DISCOUNT = exports.ANNUAL_25_PERCENT_DISCOUNT = exports.ANNUAL_20_PERCENT_DISCOUNT = exports.ANNUAL_NO_DISCOUNT = exports.MONTHLY_50_PERCENT_DISCOUNT = exports.MONTHLY_25_PERCENT_DISCOUNT = exports.MONTHLY_20_PERCENT_DISCOUNT = exports.MONTHLY_NO_DISCOUNT = exports.ANNUAL_40_PERCENT_DISCOUNT = exports.MONTHLY_40_PERCENT_DISCOUNT = exports.ANNUAL_PROMO_NO_DISCOUNT = exports.MONTHLY_PROMO_NO_DISCOUNT = undefined;

var _enviro = require('self-service-api/core/utilities/enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProd = _enviro2.default.isProd();

var MONTHLY_NO_DISCOUNT_PROD = 52;
var MONTHLY_NO_DISCOUNT_QA = 102;

var MONTHLY_PROMO_NO_DISCOUNT_PROD = 76;
var MONTHLY_PROMO_NO_DISCOUNT_QA = 141;

var MONTHLY_20_PERCENT_DISCOUNT_PROD = 57;
var MONTHLY_20_PERCENT_DISCOUNT_QA = 120;

var MONTHLY_25_PERCENT_DISCOUNT_PROD = 54;
var MONTHLY_25_PERCENT_DISCOUNT_QA = 113;

var MONTHLY_50_PERCENT_DISCOUNT_PROD = 61;
var MONTHLY_50_PERCENT_DISCOUNT_QA = 123;

var MONTHLY_30_PERCENT_DISCOUNT_PROD = 65;
var MONTHLY_30_PERCENT_DISCOUNT_QA = 126;

var MONTHLY_40_PERCENT_DISCOUNT_PROD = 74;
var MONTHLY_40_PERCENT_DISCOUNT_QA = 139;

var ANNUAL_20_PERCENT_DISCOUNT_PROD = 50;
var ANNUAL_20_PERCENT_DISCOUNT_QA = 103;

var ANNUAL_25_PERCENT_DISCOUNT_PROD = 55;
var ANNUAL_25_PERCENT_DISCOUNT_QA = 114;

var ANNUAL_BASIC_TO_PRO_DISCOUNT_PROD = 73;
var ANNUAL_BASIC_TO_PRO_DISCOUNT_QA = 138;

var ANNUAL_50_PERCENT_DISCOUNT_PROD = 64;
var ANNUAL_50_PERCENT_DISCOUNT_QA = 127;

var ANNUAL_NO_DISCOUNT_PROD = 51;
var ANNUAL_NO_DISCOUNT_QA = 118;

var ANNUAL_PROMO_NO_DISCOUNT_PROD = 77;
var ANNUAL_PROMO_NO_DISCOUNT_QA = 142;

var ANNUAL_30_PERCENT_DISCOUNT_PROD = 67;
var ANNUAL_30_PERCENT_DISCOUNT_QA = 130;

var ANNUAL_40_PERCENT_DISCOUNT_PROD = 75;
var ANNUAL_40_PERCENT_DISCOUNT_QA = 140;

var HSFX_ENTREPRENEUR_DISCOUNT_QA = 132;
var HSFX_ENTREPRENEUR_DISCOUNT_PROD = 68;

var HSFS_50_PERCENT_DISCOUNT_QA = 135;
var HSFS_50_PERCENT_DISCOUNT_PROD = 71;

var HSFS_90_PERCENT_DISCOUNT_QA = 134;
var HSFS_90_PERCENT_DISCOUNT_PROD = 70;

var ANNUAL_60_PERCENT_DISCOUNT_PROD = 62;
var ANNUAL_60_PERCENT_DISCOUNT_QA = 124;

var ANNUAL_10_PERCENT_DISCOUNT_PROD = 72;
var ANNUAL_10_PERCENT_DISCOUNT_QA = 137;

var MONTHLY_PROMO_NO_DISCOUNT = exports.MONTHLY_PROMO_NO_DISCOUNT = isProd ? MONTHLY_PROMO_NO_DISCOUNT_PROD : MONTHLY_PROMO_NO_DISCOUNT_QA;

var ANNUAL_PROMO_NO_DISCOUNT = exports.ANNUAL_PROMO_NO_DISCOUNT = isProd ? ANNUAL_PROMO_NO_DISCOUNT_PROD : ANNUAL_PROMO_NO_DISCOUNT_QA;

var MONTHLY_40_PERCENT_DISCOUNT = exports.MONTHLY_40_PERCENT_DISCOUNT = isProd ? MONTHLY_40_PERCENT_DISCOUNT_PROD : MONTHLY_40_PERCENT_DISCOUNT_QA;

var ANNUAL_40_PERCENT_DISCOUNT = exports.ANNUAL_40_PERCENT_DISCOUNT = isProd ? ANNUAL_40_PERCENT_DISCOUNT_PROD : ANNUAL_40_PERCENT_DISCOUNT_QA;

var MONTHLY_NO_DISCOUNT = exports.MONTHLY_NO_DISCOUNT = isProd ? MONTHLY_NO_DISCOUNT_PROD : MONTHLY_NO_DISCOUNT_QA;

var MONTHLY_20_PERCENT_DISCOUNT = exports.MONTHLY_20_PERCENT_DISCOUNT = isProd ? MONTHLY_20_PERCENT_DISCOUNT_PROD : MONTHLY_20_PERCENT_DISCOUNT_QA;

var MONTHLY_25_PERCENT_DISCOUNT = exports.MONTHLY_25_PERCENT_DISCOUNT = isProd ? MONTHLY_25_PERCENT_DISCOUNT_PROD : MONTHLY_25_PERCENT_DISCOUNT_QA;

var MONTHLY_50_PERCENT_DISCOUNT = exports.MONTHLY_50_PERCENT_DISCOUNT = isProd ? MONTHLY_50_PERCENT_DISCOUNT_PROD : MONTHLY_50_PERCENT_DISCOUNT_QA;

var ANNUAL_NO_DISCOUNT = exports.ANNUAL_NO_DISCOUNT = isProd ? ANNUAL_NO_DISCOUNT_PROD : ANNUAL_NO_DISCOUNT_QA;

var ANNUAL_20_PERCENT_DISCOUNT = exports.ANNUAL_20_PERCENT_DISCOUNT = isProd ? ANNUAL_20_PERCENT_DISCOUNT_PROD : ANNUAL_20_PERCENT_DISCOUNT_QA;

var ANNUAL_25_PERCENT_DISCOUNT = exports.ANNUAL_25_PERCENT_DISCOUNT = isProd ? ANNUAL_25_PERCENT_DISCOUNT_PROD : ANNUAL_25_PERCENT_DISCOUNT_QA;

var HSFX_ENTREPRENEUR_DISCOUNT = exports.HSFX_ENTREPRENEUR_DISCOUNT = isProd ? HSFX_ENTREPRENEUR_DISCOUNT_PROD : HSFX_ENTREPRENEUR_DISCOUNT_QA;

var HSFS_50_PERCENT_DISCOUNT = exports.HSFS_50_PERCENT_DISCOUNT = isProd ? HSFS_50_PERCENT_DISCOUNT_PROD : HSFS_50_PERCENT_DISCOUNT_QA;

var HSFS_90_PERCENT_DISCOUNT = exports.HSFS_90_PERCENT_DISCOUNT = isProd ? HSFS_90_PERCENT_DISCOUNT_PROD : HSFS_90_PERCENT_DISCOUNT_QA;

var ANNUAL_60_PERCENT_DISCOUNT = exports.ANNUAL_60_PERCENT_DISCOUNT = isProd ? ANNUAL_60_PERCENT_DISCOUNT_PROD : ANNUAL_60_PERCENT_DISCOUNT_QA;

var ANNUAL_50_PERCENT_DISCOUNT = exports.ANNUAL_50_PERCENT_DISCOUNT = isProd ? ANNUAL_50_PERCENT_DISCOUNT_PROD : ANNUAL_50_PERCENT_DISCOUNT_QA;

var ANNUAL_30_PERCENT_DISCOUNT = exports.ANNUAL_30_PERCENT_DISCOUNT = isProd ? ANNUAL_30_PERCENT_DISCOUNT_PROD : ANNUAL_30_PERCENT_DISCOUNT_QA;

var MONTHLY_30_PERCENT_DISCOUNT = exports.MONTHLY_30_PERCENT_DISCOUNT = isProd ? MONTHLY_30_PERCENT_DISCOUNT_PROD : MONTHLY_30_PERCENT_DISCOUNT_QA;

var ANNUAL_10_PERCENT_DISCOUNT = exports.ANNUAL_10_PERCENT_DISCOUNT = isProd ? ANNUAL_10_PERCENT_DISCOUNT_PROD : ANNUAL_10_PERCENT_DISCOUNT_QA;

var ANNUAL_BASIC_TO_PRO_DISCOUNT = exports.ANNUAL_BASIC_TO_PRO_DISCOUNT = isProd ? ANNUAL_BASIC_TO_PRO_DISCOUNT_PROD : ANNUAL_BASIC_TO_PRO_DISCOUNT_QA;

var MONTHLY_PLACEHOLDER = exports.MONTHLY_PLACEHOLDER = 99999999998;
var ANNUAL_PLACEHOLDER = exports.ANNUAL_PLACEHOLDER = 99999999999;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/TermIds.js
// module id = 116
// module chunks = 3 4 5